import React from "react";
import classNames from "classnames";
import styled from "styled-components";
import { connect } from "react-redux";
import NotificationList from "./NotificationList";
import commonStyles from "css/common.module.css";
import useNotifications from "../../hooks/useNotifications";
import { getCompanyId } from "selector/userSelectors";

const Container = styled.div.attrs({ className: "notifications" })`
  flex-direction: column;
  align-items: center;
`;

const NotificationsContainer = ({ companyId }) => {
  const { notifications, error, loading, reload } = useNotifications({
    fromArchive: true,
    companyId
  });

  return (
    <Container
      className={classNames(
        commonStyles.page,
        commonStyles.clear,
        commonStyles.flexPadded
      )}
    >
      <p className="h3">Notifications</p>
      <NotificationList
        {...{ notifications, error, loading }}
        onErrorRetry={reload}
      />
    </Container>
  );
};

export default connect(state => ({ companyId: getCompanyId(state) }))(
  NotificationsContainer
);
